//	Own-want button set
//	TODO: Ability to save this and pass events up
import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import RoundedImageIcon from './RoundedImageIcon'
import urlForUser from '../utilities/urlForUser'
import styles from './UserBar.icss'

class UserBar extends React.Component {
	constructor(props) {
		super(props)
		this.handleToggle = this.handleToggle.bind(this)
	}

	handleToggle(type) {
		const me = this
		return () => {
			const obj = {}
			obj[type] = !me.state[type]
			this.setState(obj)
		}
	}

	render() {
		const { profileImages, userName } = this.props

		return (
			<section className={styles.profileHeader}>
				<RoundedImageIcon
					className={styles.sideImg}
					content={profileImages}
					cover
					divisor={4}
				/>
				<div className={styles.spacer} />
				{!this.props.hideName && (
					<h3 className={styles.userName}><Link className={styles.link} to={urlForUser({ userName, isActivated: true })}>{userName}</Link></h3>
				)}
				<div className={styles.profileHeaderDetails}>
					{this.props.children &&
						<React.Fragment>{this.props.children}</React.Fragment>
					}
				</div>
			</section>
		)
	}
}

UserBar.contextTypes = {
	translate: PropTypes.func
}

UserBar.propTypes = {
	profileImages: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.arrayOf(PropTypes.string),
		PropTypes.shape({ type: PropTypes.string, webpurl: PropTypes.string, url: PropTypes.string }),
		PropTypes.arrayOf(PropTypes.shape({ type: PropTypes.string, webpurl: PropTypes.string, url: PropTypes.string }))
	]),
	userName: PropTypes.string,
	hideName: PropTypes.bool,
	children: PropTypes.node
}

UserBar.defaultProps = {
	profileImages: undefined,
	userName: undefined,
	hideName: false,
	children: undefined
}

export default UserBar



// WEBPACK FOOTER //
// ./src/components/UserBar.jsx